// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { showNMessageForwardedToChatSnackbar } from '$comp/snackbars'
import { forwardMessages } from '$logic/message'
import { ForwardMenu } from './forward-menu'

const COMPONENT_ID = 'forwardMenu'

export const openForwardMenuModal = (
  props: Parameters<typeof ForwardMenu>[0],
) => addModal({ id: COMPONENT_ID, props })

export const showForwardMenuModal = async (
  sourceRoomId: string,
  iids: number[],
  forwardLimit?: number,
) => {
  return openForwardMenuModal({
    forwardLimit,
    onConfirm: (roomIds, caption) => {
      analite('MESSAGE_FORWARD', {
        multiple: iids.length > 1,
        source: 'FORWARD_MENU_MODAL',
      })
      return forwardMessages(
        roomIds,
        { roomId: sourceRoomId, iids },
        caption,
      ).then(() =>
        showNMessageForwardedToChatSnackbar(roomIds.length, iids.length > 1),
      )
    },
  })
}

export default {
  [COMPONENT_ID]: {
    Component: ForwardMenu,
  },
}
